<template>
    <div class="apprentice-simple-card files-management">
        <design-2021-apprentice-data-table
            :fields="fields"
            :items="surveys">
            <template v-slot:options>
                <div class="apprentice-group-table-actions">
                    <b-button
                        class="btn-add btn-new-assignment-servey"
                        v-b-modal="'assignment-rubric-add-survey'"
                        variant="primary">
                        {{ $t('group.rubric_survey.new_invitation') }}
                    </b-button>
                </div>

                <design-2021-group-show-rubric-survey-add-modal-component
                    :group-in="groupIn"
                    @survey-added="addSurvey($event)">
                </design-2021-group-show-rubric-survey-add-modal-component>
            </template>

            <template v-slot:cell(created_at)="data">
                {{ data.item.created_at | date_named_month_short }}
            </template>

            <template v-slot:cell(progress)="data">
                <b-progress :max="getMax(data.item)">
                    <!--                    todo not optimized-->
                    <b-progress-bar
                        show-progress
                        :value="getResult(data.item)"
                        :label="`${((getResult(data.item) / getMax(data.item)) * 100).toFixed(0)}%`"></b-progress-bar>
                </b-progress>
            </template>

            <template v-slot:cell(action)="data">
                <div class="group-actions">
                    <b-button
                        class="btn-open btn-open-group"
                        v-b-tooltip="'Info'"
                        variant="primary-icon-only"
                        @click="showRubricSurvey(data.item)">
                    </b-button>
                    <b-button
                        class="btn-remove btn-remove-group"
                        variant="danger-icon-only"
                        :v-b-tooltip="$t('common.delete')"
                        @click="deleteRubricSurvey(data.item)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-show-rubric-survey-component',
    props: {
        groupIn: Object,
    },
    data() {
        return {
            surveys: this.groupIn.rubric_surveys,
            fields: [
                {
                    key: 'created_at',
                    label: this.$t('group.rubric_survey.date'),
                },
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'progress',
                    label: this.$t('group.rubric_survey.progress'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    methods: {
        addSurvey(survey) {
            this.surveys.push(survey);
        },
        getMax(item) {
            let count = item.rubric_survey_users.length;

            for (const rubricSurveyUser of item.rubric_survey_users) {
                count += rubricSurveyUser.peers.length;
            }

            return count;
        },

        getResult(item) {
            let count = 0;

            for (const rubricSurveyUser of item.rubric_survey_users) {
                if (!rubricSurveyUser.rubric_forms.length) {
                    continue;
                }

                count += rubricSurveyUser.rubric_forms[0].rubric_form_results.length;
            }

            return count;
        },

        showRubricSurvey(item) {
            window.location.href = this.routes.showRubricSurvey(item.id);
        },

        deleteRubricSurvey(item) {
            this.alert
                .confirm(
                    this.$t('group.rubric_survey.delete_skill'),
                    this.$t('group.rubric_survey.are_you_sure_you_want_to_delete_this_skill'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.delete(this.routes.deleteRubricSurvey(item.id)).then(
                            (response) => {
                                this.surveys = this.surveys.filter((survey) => item.id !== survey.id);
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
    },
};
</script>

<style scoped lang="scss">
.group-actions {
    display: flex;
    flex-direction: row;
    align-items: center;

    .btn {
        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }
    }

    .btn-open-group {
        margin-right: map-get($grid-gutter-spacing, 'twenty-one');
    }
}
</style>
